import { EvaluationDetails, INationalAverage, ISubsection } from 'type'
import { findCandidateResultByID, findThePaperByEvaluationId } from 'gql/query'

export const nationalAverageForSectionWise = async (allEvaluationDetails: EvaluationDetails[]) => {
  try {
    const paperSubsectionDetails: ISubsection[] = []
    await Promise.all(
      (allEvaluationDetails ?? []).map(async item => {
        let evaluationId = item?.id
        let candidatesEvaluation = item?.evaluation_candidates
        const evaluationDetails: any = await findThePaperByEvaluationId(evaluationId ? evaluationId : '')
        const details = evaluationDetails?.evaluations[0]
        const paperSubsectionsWithItsIds = details?.paper?.subSectionQuestions
        await Promise.all(
          (candidatesEvaluation ?? []).map(async candidate => {
            const candidataAnswers: any = await findCandidateResultByID(candidate?.id)

            if (candidataAnswers && candidataAnswers.evaluation_details && candidataAnswers.evaluation_details.length > 0) {
              const candidateResultArrayForEachQuestion = candidataAnswers.evaluation_details[0].answers
            } else {
              console.log('No evaluation details found for candidate', candidate?.id)
            }
          })
        )
      })
    )
  } catch (err) {
    console.log(err, ':error happened when calculating section wise national average')
  }
}

export const changeFormatCandidateWise = async (evaluationDetails: any) => {
  const newData: any[] = []
  evaluationDetails.forEach((detail: any) => {
    if (detail.evaluation_candidates.length >= 1) {
      detail.evaluation_candidates.forEach((candidate: any) => {
        const newItem = {
          id: candidate.id,
          total_score: candidate.total_score,
          evaluation_id: detail.id,
          paper: detail.paper,
        }
        newData.push(newItem)
      })
    }
  })

  return newData
}
